import React from "react";
import {NextButton} from "../components/buttons";
import * as images from "../components/splash-page-images";


export default (props) => (
  <div id="splash" className="animated fadeIn has-text-left">
    <div className="container">
      <div className="columns">
        <div className="column is-half is-offset-one-quarter is-10-mobile is-offset-1-mobile">
          <div className="header">
            <h1>
              How much money could your class be saving on textbooks?
            </h1>
          </div>
          <div className="small-break is-danger"></div>
        </div>
      </div>
      <div className="columns">
        <div className="column is-half is-offset-one-quarter is-10-mobile is-offset-1-mobile">
          <div>
            <h2>
              Check out the statistics:
            </h2>
          </div>
        </div>
      </div>
      <div className="columns statistics">
        <div className="column is-offset-1 is-10 is-10-mobile is-offset-1-mobile">
          <div className="columns">
            <div className="column is-half statistics-left">
              <section className="section statistic">
                <div className="img-container has-text-centered"><img src={images.chart} alt=""/></div>
                <p>Textbooks have risen 1,041% in price since 1977. That’s more than three times the rate of inflation.</p>
              </section>
            </div>
            <div className="column is-half statistics-right">
              <section className="section statistic">
                <div className="img-container"><img src={images.illustration} alt=""/></div>
                <p>The average full-time student spends about $1,000 on textbooks every year.</p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column is-half is-offset-one-quarter is-10-mobile is-offset-1-mobile">
          <section className="statistic-blurb">
            <p>
              When <strong>65 percent of students are opting not to buy the latest editions of
              already-out-of-date textbooks</strong>, the fix is in: Something’s rotten in the state of
              educational publishing. Luckily, the rise of technology in the classroom has resulted
              in high-quality alternatives to outdated and expensive print textbooks—alternatives
              that mean major savings for students.
            </p>
          </section>
          <section>
            <h3>
              Our Textbook Affordability Calculator will tell you just how much money
              your students stand to save by foregoing traditional textbooks.
            </h3>
          </section>
          <section id="calculator-start" className="has-text-centered">
            <NextButton text="Curious? Get started now." {...props}/>
          </section>
        </div>
      </div>
    </div>
  </div>
)




// WEBPACK FOOTER //
// ./src/pages/splash.js